module.exports = __webpack_public_path__ + "static/2-4cc2c900a9a46e21e01106911337b810.jpeg";